//Account reducer

import { initializeState } from '../../../utilities/storageUtils';
import accountActionTypes from './account.types';

const INITIAL_STATE = {
  userIsLoggedIn: false,
  creatingNewAccount: false,
  newAccountHasSucceded: false,
  newAccountValidationErrors: null,
  newAccountErrorMessage: '',
  loginErrorMessage: '',
  loginHasFailed: false,
  currentLoggedInUser: null
};

const accountReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  // Account information reducers
  switch (action.type) {
    // Set if user is already logged in
    case accountActionTypes.CURRENT_ACCOUNT_USER_IS_LOGGED_IN:
      return {
        ...state,
        userIsLoggedIn: action.userIsLoggedIn
      };

    case accountActionTypes.CURRENT_ACCOUNT_LOGGED_IN_USER:
      return {
        ...state,
        currentLoggedInUser: action.currentLoggedInUser
      };

    case accountActionTypes.UPDATE_ACCOUNT_USER_POINTS_AND_OFFERS:
      return {
        ...state,
        currentLoggedInUser: {
          ...state.currentLoggedInUser,
          pointsBalance: action.pointsBalance,
          offerList: action.offerList
        }
      };

    // A new account is being created
    case accountActionTypes.POST_ACCOUNT_NEW_LOADING:
      return {
        ...state,
        creatingNewAccount: action.creatingNewAccount
      };
    // The new account request has successfully finished
    case accountActionTypes.POST_ACCOUNT_NEW_SUCCESS:
      return {
        ...state,
        newAccountHasSucceded: true,
        creatingNewAccount: false,
        newAccountValidationErrors: null,
        newAccountErrorMessage: ''
      };
    // The new account request has successfully finished
    case accountActionTypes.POST_ACCOUNT_NEW_ERROR:
      return {
        ...state,
        newAccountHasSucceded: false,
        creatingNewAccount: false,
        newAccountValidationErrors: action.newAccountValidationErrors,
        newAccountErrorMessage: action.newAccountErrorMessage
      };
    // Reset all values to their initial state
    case accountActionTypes.RESET_ACCOUNT_NEW_TO_INITIAL_STATE:
      return {
        ...state,
        creatingNewAccount: false,
        newAccountHasSucceded: false,
        newAccountValidationErrors: null,
        newAccountErrorMessage: ''
      };
    // Set an login error
    case accountActionTypes.LOGIN_ACCOUNT_ERROR_TYPE:
      return {
        ...state,
        loginErrorMessage: action.loginErrorMessage,
        loginHasFailed: true
      };

    //Update Loyalty Flagh
    case accountActionTypes.LOYALTY_ACCOUNT_OPT_IN:
      return {
        ...state,
        currentLoggedInUser: { ...state.currentLoggedInUser, loyaltyOptIn: action.loyaltyOptIn }
      };
    //Update currentLoggedInUser with the memberId and referralCode
    case accountActionTypes.UPDATE_ACCOUNT_MEMBER_ID_AND_REFERRAL_CODE:
      return {
        ...state,
        currentLoggedInUser: {
          ...state.currentLoggedInUser,
          loyaltyMemberId: action.loyaltyMemberId,
          loyaltyReferralCode: action.loyaltyReferralCode
        }
      };

    // Reset all account methods
    case accountActionTypes.RESET_ACCOUNT_METHODS:
      return {
        creatingNewAccount: false,
        newAccountHasSucceded: false,
        newAccountValidationErrors: null,
        newAccountErrorMessage: '',
        loginErrorMessage: '',
        loginHasFailed: false
      };
    default:
      return state;
  }
};

export default accountReducer;
